import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pace-forms2',
    templateUrl: './forms2.component.html',
    styleUrls: ['./forms2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Forms2Component {}
